import React, { useState } from 'react'
import SeatTab from './seatTab'
import SeatSelectionPanel from './SeatSelectionPanel'
import BusBoarding from './busBoarding'
import BusPhotos from './busPhotos'
import BusRating from './busRating'
import BusCancel from './busCancel'

// Owns which tab (SELECT SEAT / BOARDING/DROP POINTS / PHOTOS & AMENITIES /
// RATINGS & REVIEWS / CANCELLATION) is active and swaps the content panel
// accordingly — same tab bar, same spot, like flight's FlightDetails tabs.
// Used both inline under a bus result card's "VIEW SEATS" (see
// BusResults.jsx) and by the standalone preview pages.
const SeatBookingPanel = ({ initialTab = 'selectSeat' }) => {
    const [activeTab, setActiveTab] = useState(initialTab)

    return (
        <>
            <SeatTab active={activeTab} onChange={setActiveTab} />
            {activeTab === 'selectSeat' && <SeatSelectionPanel onContinue={() => setActiveTab('boardingDrop')} />}
            {activeTab === 'boardingDrop' && <BusBoarding />}
            {activeTab === 'photosAmenities' && <BusPhotos />}
            {activeTab === 'ratingsReviews' && <BusRating />}
            {activeTab === 'cancellation' && <BusCancel />}
        </>
    )
}

export default SeatBookingPanel
